import React from 'react';
import PropTypes from 'prop-types';
import { QuestionMark } from 'tabler-icons-react';
import { NavLink } from '@mantine/core';
import { Link } from 'react-router-dom';
import AppStack from '../../common/AppStack';
import AppCard from '../../common/AppCard';
import SUPPORT_LINKS from './supportLinks';
import SidebarNavSections from './SidebarNavSections';
import SidebarNavButton from './SidebarNavButton';

const Sidebar = ({ navigation, state }) => (
  <AppCard
    shadow="xs"
    style={{
      height: 'calc(100vh - 60px)',
      width: '100%',
      padding: 0,
      maxWidth: 240,
      minWidth: 240,
      position: '-webkit-sticky',
      position: 'sticky',
      top: 60,
      flex: 1,
      gap: 0,
      backgroundColor: '#FFF'
    }}
    visibleFrom="sm"
  >
    <AppStack
      style={{
        overflow: 'auto',
        flex: 1,
        gap: 5
      }}
    >
      <AppStack
        style={{
          padding: '16px 0px',
          gap: 0,
          flex: 1
        }}
      >
        <SidebarNavSections sections={navigation.main} state={state} />

        {navigation.sections?.map((s) => (
          <AppStack key={s.title} style={{ gap: 0, marginTop: 30 }}>
            <NavLink
              component={Link}
              label={s.title}
              rightSection={s.icon ? <s.icon color="grey" size={15} /> : null}
              style={{
                fontSize: 16,
                fontWeight: 600,
                padding: '3px 10px',
                color: 'grey'
              }}
              to={s.links[0]?.to}
            />
            <SidebarNavSections
              key={s.title}
              sections={s.links}
              state={state}
            />
          </AppStack>
        ))}
      </AppStack>
      <AppStack
        style={{
          padding: 5,
          paddingBottom: 10,
          gap: 0
        }}
      >
        <SidebarNavButton
          color="#000"
          IconComponent={QuestionMark}
          label="Support"
          link={SUPPORT_LINKS.index.href}
          target="_blank"
        />
      </AppStack>
    </AppStack>
  </AppCard>
);

Sidebar.propTypes = {
  navigation: PropTypes.object,
  state: PropTypes.object
};

export default Sidebar;
